export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14074.456f9f8c.jpg";